<template>
  <div>
    <div v-text="content"></div>
  </div>
</template>

<script>
import data from "@/assets/content.js";
export default {
  
  data() {
    return {
      content: data 
    }}
};
</script>
